import { IonButton, IonSpinner } from "@ionic/react";
import Box from "@mui/material/Box";
import { DataGrid , deDE } from "@mui/x-data-grid";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { AppContext } from "../contexts/app_context";
import './table_geraete_grid.css';
import { useGefahrstoffschulungenThemen } from "./_CustomHooks";
import { ButtonAdd , ButtonInaktive, defColumn , exportTableData , getLoadErr } from './_HelperFunctions' ;

function GefahrstoffschulungenThemenTable() {
  const { appKundeId , appGefahrstoffschulungenThemenFetchstate , appGefahrstoffschulungenThemen , appGefahrstoffschulungenThemaIdChange , appViewSwitchChange } = useContext( AppContext ) ;
  const history = useHistory();
  const [pageSize, setPageSize] = useState(50);
  const [ localGefahrstoffschulungenThemen , localGefahrstoffschulungenThemenChange ] = useState( Array() ) ;
  const [ existInaktive , setExistInaktive ] = useState( false ) ;
  const [ showInaktive , setShowInaktive ] = useState( false ) ;
  const setColumns = ( tablePurpose:string ):any => {
    if( tablePurpose === 'GefahrstoffschulungenThemen' ) {
      return (
        [
          defColumn( 'SchulungenId' , 'ID' , 0 ) ,
          defColumn( 'SchulungenTitel' , 'Thema' , 300 ) ,
          defColumn( 'SchulungenAktiv' , 'aktiv' , 80 , 0 ) ,
          defColumn( 'SchulungenPflicht' , 'Pflicht' , 80 , 0 ) ,
          {
            field: "SchulungenTurnus",
            headerName: "Turnus",
            headerClassName: "super-app-theme--header",
            minWidth: 200 ,
            flex: 0 ,
            renderCell: ( params:any ) => {
              if ( params.row.SchulungenTurnus === "0" ) {
                return 'nicht festgelegt'
              }
              if ( params.row.SchulungenTurnus === "1" ) {
                return 'Erstschulung'
              }
              if ( params.row.SchulungenTurnus === "90" ) {
                return 'vierteljährlich'
              }
              if ( params.row.SchulungenTurnus === "180" ) {
                return 'halbjährlich'
              }
              if ( params.row.SchulungenTurnus === "365" ) {
                return 'jährlich'
              }
              if ( params.row.SchulungenTurnus === "730" ) {
                return 'zwei Jahre'
              }
            }
          } ,
        ]
      )
    }
  }
  useGefahrstoffschulungenThemen() ;

  const handleInaktive = () =>
    {
      if( showInaktive ) {
        localGefahrstoffschulungenThemenChange( appGefahrstoffschulungenThemen )
      }
      else {
        localGefahrstoffschulungenThemenChange(
          appGefahrstoffschulungenThemen
            .filter(
              ( entry:any ) => entry.SchulungenAktiv === 'aktiv'
            )        
        )
      }
    }

    useEffect(
      () => {
        if( appGefahrstoffschulungenThemen
            .findIndex(
              ( entry:any ) => entry.SchulungenAktiv === 'inaktiv'
            ) > -1
        )
          {
            setExistInaktive( true )
          }
        else
          {
            setExistInaktive( false )
          }
        handleInaktive() ;
      } ,
      [ appGefahrstoffschulungenThemen ]
    )
    
    useEffect(
      () => {
        handleInaktive() ;
      } ,
      [ showInaktive ]
    )
    
      const mkTable = ( tablePurpose:string , singleGUI:string ) =>  {
    return (
      <Box
        sx={{
          height: 600,
          width: 1,
          "& .super-app-theme--header": {
            backgroundColor: "rgb(211,211,211)",
          },
        }}
      >
        {
          appGefahrstoffschulungenThemenFetchstate !== 200 && appGefahrstoffschulungenThemenFetchstate !== 204 ?
          (
            appGefahrstoffschulungenThemenFetchstate === 100
              ? <IonSpinner name="bubbles" />
              : <div style={{ margin: '30%' , opacity: '40%' , textAlign: 'center' }}>
                  { getLoadErr( appGefahrstoffschulungenThemenFetchstate ) }
                </div> 
          ) : (
            <>
              <DataGrid
                componentsProps = {{
                  toolbar: {
                    tablePurpose: tablePurpose
                  }
                }}
                initialState={{
                  sorting: {
                    sortModel: [ { field: 'SchulungenTitel' , sort: 'asc' } ] ,
                  },
                }}
                getRowId={(row:any) => row.SchulungenId} 
                getRowClassName =
                  {
                    ( data:any ) => data.row.SchulungenAktiv === 'inaktiv' ? 'eintrag_inaktiv' : ''
                  }
                rows={localGefahrstoffschulungenThemen}
                columns={ setColumns( tablePurpose ) } 
                disableVirtualization 
                rowsPerPageOptions={[50,100]}
                disableSelectionOnClick
                sortingOrder={["desc", "asc"]}
                onCellClick = {
                  ( e ) =>
                    {
                      appViewSwitchChange( true ) ;
                      appGefahrstoffschulungenThemaIdChange( e.id ) ; 
                      history.push( '/' + singleGUI + '/' + e.id + '/' + appKundeId ) ;
                    }
                }
                // checkboxSelection
                pageSize={pageSize}
                onPageSizeChange={(newPage) => setPageSize(newPage)}
                //onCellClick={(e) => tryme(e.row)}
                // rowsPerPageOptions={[5, 10, 20]}
                pagination
                localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
              />
              <ButtonInaktive
                disabled = { existInaktive ? false : true }
                myExec = {
                  () =>
                    {
                      setShowInaktive( showInaktive ? false : true )
                    }
                  }
                label = { showInaktive ? 'Inaktive ausblenden' : 'Inaktive anzeigen' }
              />
              <ButtonAdd
                myExec = { () => { appGefahrstoffschulungenThemaIdChange( 'neu' ) ; } }
                routeUrl = { '/' + singleGUI + '/neu/' + appKundeId }
              />
              {
                localGefahrstoffschulungenThemen.length > 0
                  ?
                    <IonButton onClick={ () => exportTableData( appGefahrstoffschulungenThemen , 'GefahrstoffschulungenThemen' ) }>Exportieren</IonButton>
                  :
                    ''
              }
              {
                showInaktive
                  ?
                    <p style = { { fontSize: '0.8em' , fontWeight: 'bold' , marginLeft: '0.5em' , marginTop: '0' } } >
                      Inaktive Themen sind <span className = "eintrag_inaktiv">hellgrau</span> markiert
                    </p>
                  :
                    ''
              }
            </>
          )
        }
      </Box>
    )
  }
  return (
    <>
      { mkTable( 'GefahrstoffschulungenThemen' , 'gefahrstoffschulungsthema' ) }
    </>
  );
}
export default GefahrstoffschulungenThemenTable;
